import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { detailedServices } from '../../data/servicesData';

const RelatedServices = ({ currentSlug }) => {
  const idx = detailedServices.findIndex((s) => s.slug === currentSlug);
  const related = [1, 2, 3].map((n) => detailedServices[(idx + n) % detailedServices.length]);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="related-services">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'var(--font-serif)' }}>
        Pairs well with
      </h2>
      <div className="grid md:grid-cols-3 gap-6">
        {related.map((s) => (
          <Link
            key={s.slug}
            to={`/services/${s.slug}`}
            data-testid={`related-${s.slug}`}
            className="group rounded-xl border border-gray-200 p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 bg-gradient-to-br from-white to-orange-50"
          >
            <h3 className="font-bold text-gray-900 text-lg mb-2">{s.title}</h3>
            <p className="text-gray-600 text-sm mb-4">{s.tagline}</p>
            <span className="inline-flex items-center gap-1 text-sm font-semibold" style={{ color: '#D97904' }}>
              From ${s.tiers[0].price.toLocaleString()} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedServices;
